import { useState, useEffect, useTransition } from "react";
import logo from "../assets/logo.png";
import { ArrowLeft, Languages, } from "lucide-react"; // Import ArrowLeft icon
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { BASE_URL, getWithoutTokenAPI, postWithoutTokenAPI } from "../util/Api";
import "../styles/LoginPage.css";
import { Header } from "./Header";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function LoginPage({ onNavigate }) {
  const [formData, setFormData] = useState({ mobile: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setFormData({ ...formData, mobile: value });
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.mobile) {
      setError(t("Phone number is required"));
      return;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      setError(t("Phone number must be exactly 10 digits"));
      return;
    }

    try {
      const payload = { mobile_number: formData.mobile };
      const response = await postWithoutTokenAPI(
        BASE_URL + "/auth/send-otp",
        payload
      );
      if (response?.statusCode === 200) {
        toast.success(`${t('OTP Sent Successfully')}`)
        navigate("/otp", {
          state: { mobile: formData.mobile }
        });
      } else {
        console.log("Failed to send OTP. Please try again");
        toast.error(`${t("Failed to send OTP. Please try again")}`)
      }
    } catch {
      setError(t("Something went wrong. Please try again"));
      toast.error(`${t("Something went wrong. Please try again")}`)
    }
  };

  // Back button handler
  const handleBack = () => {
    navigate(-1); // Go back to previous page
    // Or you can use: navigate('/') to go to home page
  };

  // const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState("en");

  const changeLanguage = () => {
    const newLang = currentLang === "en" ? "ta" : "en";
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };
  return (
    <>
      {/* Updated Header with Back Button */}
      <div className="bg-white shadow-sm border-b border-border">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Back Button on Left End */}
            <button
              onClick={() => { navigate('/') }}

              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg font-medium">{t("Back")}</span>
            </button>



            <div className="w-20">
              <Button
                variant="ghost"
                size="sm"
                onClick={changeLanguage}
                className="avan-avala-language-btn hidden md:flex items-center space-x-1 text-gray-600 cursor-pointer hover:text-red-500"
              >
                <Languages className="w-4 h-4" />
                <span className="avan-avala-language-text text-sm font-medium">
                  {currentLang === "en" ? "தமிழ்" : "English"}
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Toaster position="top-right" />
      <div className="login-wrapper">
        {/* Left Image Section */}
        <div className="login-left">
          <ImageWithFallback
            src="/Images/authentic-indian-bride-groom.jpg"
            alt="Couple"
            className="login-image"
          />
          <div className="login-overlay">
            <h2>{t("Welcome Back!")}</h2>
          </div>
        </div>

        {/* Right Form Section */}
        <div className="login-right">
          <Card className="login-card">
            <CardHeader className="text-center">
              <div className="image">
                <img src={logo} alt="Aishwarya matrimony" />
              </div>
              <CardTitle className="text-2xl font-bold">
                {t("Sign In / Sign Up")}
                <p>{t("Continue your journey to find your perfect life partner")}</p>
              </CardTitle>
            </CardHeader>

            <CardContent>
              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <Label htmlFor="mobile">{t("Mobile Number")}</Label>
                  <Input
                    id="mobile"
                    type="tel"
                    placeholder={t("Enter your mobile number")}
                    value={formData.mobile}
                    maxLength={10}
                    onChange={handleMobileChange}
                    className={error ? "input-error" : ""}
                  />
                  {error && <span className="error-text">{error}</span>}
                </div>
                <Button type="submit" className="text-white cursor-pointer" style={{ background: 'linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))' }}>
                  {t("Send OTP")}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
